import {
  MdAbc,
  MdAccessibilityNew,
  MdArticle,
  MdChair,
  MdContactSupport,
  MdDirectionsWalk,
  MdEmojiEvents,
  MdFitnessCenter,
  MdFlag,
  MdFormatQuote,
  MdGridOn,
  MdGridView,
  MdHealing,
  MdHelpOutline,
  MdLiveTv,
  MdLunchDining,
  MdMood,
  MdNightsStay,
  MdPublic,
  MdQuiz,
  MdRadio,
  MdRestaurant,
  MdSelfImprovement,
  MdSentimentSatisfiedAlt,
  MdShoppingBasket,
  MdSpa,
  MdSportsGymnastics,
  MdSportsSoccer,
  MdVisibility,
  MdWaterDrop,
  MdWavingHand,
} from "react-icons/md";

const ICONS = {
  abc: MdAbc,
  "accessibility-new": MdAccessibilityNew,
  article: MdArticle,
  chair: MdChair,
  "contact-support": MdContactSupport,
  "directions-walk": MdDirectionsWalk,
  "emoji-events": MdEmojiEvents,
  "fitness-center": MdFitnessCenter,
  flag: MdFlag,
  "format-quote": MdFormatQuote,
  "grid-on": MdGridOn,
  "grid-view": MdGridView,
  healing: MdHealing,
  "help-outline": MdHelpOutline,
  "live-tv": MdLiveTv,
  "lunch-dining": MdLunchDining,
  mood: MdMood,
  "nights-stay": MdNightsStay,
  public: MdPublic,
  quiz: MdQuiz,
  radio: MdRadio,
  restaurant: MdRestaurant,
  "self-improvement": MdSelfImprovement,
  "sentiment-satisfied-alt": MdSentimentSatisfiedAlt,
  "shopping-basket": MdShoppingBasket,
  spa: MdSpa,
  "sports-gymnastics": MdSportsGymnastics,
  "sports-soccer": MdSportsSoccer,
  visibility: MdVisibility,
  "water-drop": MdWaterDrop,
  "waving-hand": MdWavingHand,
};

export default function MaterialIcon({ name, className }) {
  const Icon = ICONS[name] || MdHelpOutline;
  return <Icon className={className} aria-hidden="true" />;
}
